import { Link } from "react-router-dom";
import { ArrowRight, Heart } from "lucide-react";
import { trackEvent } from "../lib/analytics";

// Small post-purchase affiliate invitation. Never placed inside the purchase funnel.
export function AffiliateInvite({ surface, className = "" }) {
  return (
    <aside className={`border border-zinc-800 bg-[#0a070d] p-5 ${className}`} data-testid={`affiliate-invite-${surface}`}>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex gap-3">
          <Heart size={18} className="mt-0.5 shrink-0 text-purple-300" aria-hidden="true" />
          <div>
            <p className="font-display text-lg font-black text-white">Love Stag Vault?</p>
            <p className="mt-1 text-sm text-zinc-400">Recommend it to someone who would benefit and earn commission from qualifying sales.</p>
          </div>
        </div>
        <Link to="/affiliates" onClick={() => trackEvent("AffiliateCtaClick", { surface })} className="inline-flex min-h-11 items-center gap-2 border border-purple-400 px-4 text-xs font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-purple-500 hover:text-black" data-testid={`affiliate-invite-cta-${surface}`}>Earn with Stag Vault <ArrowRight size={14} aria-hidden="true" /></Link>
      </div>
    </aside>
  );
}
